
function PlugableControlBase() {


    this.OnChange = function (vueInstance) {
        this.$emit("change", this.GetControlXml());

        if (this.$parent != null && this.$parent.OnChildControlChange != null) {
            this.$parent.OnChildControlChange(vueInstance);
        }
    };

    this.ConvertObjectToXml = function (dataObject, tagName) {
        let dataXml = "";
        let contentXml = "";
        let beginTag, endTag;
        let childTagName;
        let sourcePropertyName;
        let propertyNameAttributeParameter = "";
        let i, j;



        if (tagName.match(/[A-Z]+/) != null) {
            propertyNameAttributeParameter = ` PropertyName="${tagName}" `
        }

        if (dataObject != null && typeof (dataObject) == "object" && Array.isArray(dataObject)) {
            beginTag = `    <${tagName} Type="Array" ${propertyNameAttributeParameter}>
`;
            endTag = `    </${tagName}>
`;
        }
        else if (dataObject != null && typeof (dataObject) == "object" && !Array.isArray(dataObject)) {
            beginTag = `    <${tagName} Type="Object" ${propertyNameAttributeParameter}>
`;
            endTag = `    </${tagName}>
`;
        }
        else {

            if (typeof (dataObject) == "boolean") {
                beginTag = `    <${tagName} Type="Boolean" ${propertyNameAttributeParameter}>`;
            }
            else if (typeof (dataObject) == "number") {
                beginTag = `    <${tagName} Type="Number" ${propertyNameAttributeParameter}>`;
            }
            else {
                beginTag = `    <${tagName}>`;
            }

            endTag = `</${tagName}>
`;
        }


        if (typeof (dataObject) == "object" && !Array.isArray(dataObject)) {

            for (i in dataObject) {
                if (i != "ControlId" && i != "ControlType" ) {
                    if (i.indexOf("$NotCommitted") > 0) {
                        sourcePropertyName = i.replace("$NotCommitted", "");
                        dataObject[sourcePropertyName] = dataObject[i];
                        delete dataObject[i];
                    }
                }
            }

            for (i in dataObject) {
                if (i != "ControlId" && i != "ControlType" && i.indexOf("m_") != 0) {
                    contentXml +=
                        "    " + this.ConvertObjectToXml(dataObject[i], i) + "\r\n";
                }
            }
        }
        else if (dataObject != null && Array.isArray(dataObject)) {

            for (i = 0; i < dataObject.length; i++) {
                childTagName = tagName.replace("list", "");
                contentXml +=
                    "    " + this.ConvertObjectToXml(dataObject[i], childTagName) + "\r\n";
            }
        }
        else {
            if (dataObject != null) {
                contentXml += dataObject;
            }
        }

 
        if (tagName == "props" && contentXml.trim() == "") {
            dataXml = "";
        }
        else if (contentXml != "") {
            dataXml = beginTag + contentXml + endTag;
        }

        //if (dataXml.indexOf(`type="Array"`) >= 0) {
        //    debugger;
        //}

        return dataXml;
    };


    this.GetControlXml = function () {
        let controlXml = "";
        let dataXml;
        let propsXml;


        controlXml = `
    <control Type="${this.ControlType}" >
`;


        if (this.$props != null) {
            propsXml = this.ConvertObjectToXml(this.$props, "props");

            controlXml += propsXml;
        }

        dataXml = this.ConvertObjectToXml(this.$data, "data");

        controlXml += dataXml;

        controlXml += `
    </control>
`;
        return controlXml;
    };

}

PlugableControlBase.ElementSerialNo = 1


export default PlugableControlBase;
